import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useSweetAlert } from '@/composables/sweetalert';
import { EmergencyAnswerAction, EmergencyAnswerGetter } from '@/store/emergencyAnswer/emergencyAnswer.module';
import { EmergencyAnswer, EmergencyAnswerAttachment } from '@/store/emergencyAnswer/emergencyAnswer.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'EmergencyAnswerImageModalComponent',
  components: {
    BaseModalComponent,
  },
  props: {
    emergencyId: {
      type: Number,
    },
    emergencyAnswerId: {
      type: Number,
    },
  },
  setup: (props) => {
    const store = useStore();
    const swal = useSweetAlert();
    const emergencyAnswer = computed<EmergencyAnswer | undefined>(() => store.getters[EmergencyAnswerGetter.BY_ID](props.emergencyAnswerId));
    const images = computed<EmergencyAnswerAttachment[]>(() => (emergencyAnswer.value?.emergencyAnswerAttachments) ? emergencyAnswer.value?.emergencyAnswerAttachments.filter(m => m.attachmentType.id === 2) : []);
    const isLoading = computed(() => store.getters[EmergencyAnswerGetter.STATUS] === 'init' || store.getters[EmergencyAnswerGetter.STATUS] === 'loading');
    const imageModal = ref<InstanceType<typeof BaseModalComponent>>();
    const fileDialog = ref<HTMLInputElement>();

    // show modal
    const show = () => {
      imageModal.value?.show();
    };

    // hide modal
    const hide = () => {
      imageModal.value?.hide();
    };

    // open file dialog
    const fileDialogOpen = () => {
      fileDialog.value?.click();
    };

    const fileDialogChange = () => {
      const files = fileDialog.value?.files as FileList;
      store.dispatch(EmergencyAnswerAction.ADD_ATTACHMENTS, {
        emergencyId: props.emergencyId,
        id: emergencyAnswer.value?.id,
        attachmentTypeId: 2,
        names: Array(files.length).fill('image'),
        attachments: files,
      });
    };

    const deleteImage = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(EmergencyAnswerAction.REMOVE_ATTACHMENTS, {
              emergencyId: props.emergencyId,
              id: emergencyAnswer.value?.id,
              attachmentIds: [id],
            });
          }
        });
    };

    return {
      images,
      imageModal,
      fileDialog,
      isLoading,
      show,
      hide,
      fileDialogOpen,
      fileDialogChange,
      deleteImage,
    };
  }
});
